import fetchServer from "../../../fetchServer";

function parseRefundResponse(res, fallbackMsg) {
  if (!res) {
    return { return: 0, msg: fallbackMsg, data: [], code: null };
  }

  const payload = res.data ?? res;
  const nested =
    payload?.data && typeof payload.data === "object" ? payload.data : payload;
  const httpOk = res.status >= 200 && res.status < 300;

  if (httpOk) {
    return {
      return: 1,
      msg: payload?.message || "Successfull",
      data: payload?.data ?? payload,
      code: null,
    };
  }

  return {
    return: 0,
    msg: nested?.error || payload?.error || payload?.message || fallbackMsg,
    data: nested || [],
    code: nested?.code ?? payload?.code ?? null,
  };
}

export default async function refundTicketRequest(id) {
  var result = {
    return: 0,
    msg: "Failed refunding ticket",
    data: [],
    code: null,
  };

  await fetchServer({
    method: "PATCH",
    url: `/product/v1/refund/confirm/${id}`,
  })
    .then((res) => {
      result = parseRefundResponse(res, result.msg);
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}
